import { KatInput, KatLabel, KatInputGroup } from '@amzn/katal-react';
import React from 'react'
import { getMaxLength, getRequiredLabel, getValue, handleError } from './widgetUtil';
import { convertHtmlToPlainText } from '../../utils/formUtils';
import { has } from 'lodash';
import { WidgetProps } from 'react-jsonschema-form';
import { NUMBER, TEXT } from '../../appConstants';
import * as constants from '../../appConstants';

class InputWidget extends React.Component<WidgetProps> {

    /**
     * Identifies KatalInput type from DDM Schema.
     * @param schema DDM Schema
     * @return Katal Input Type
     * Supported Types ('text', 'integer')
     * https://katal.corp.amazon.com/#/component/developer/KatalInput
     */
    identifyKatalInputType = (schema: any): KatInput.Type => {
        if (has(schema, 'type')) {
            const schemaInputType = schema.type;
            if (schemaInputType === NUMBER) {
                return NUMBER;
            }
        }
        // default to text.
        return TEXT;
    };

    handleChange = (evt: any, onChange: Function, defaultValue: string) => {
        evt.preventDefault();
        let value = getValue(evt.target.value, defaultValue);
        onChange(value);
    };

    input() {
        let defaultValue = this.props.schema.default;
        let {state, stateEmphasis, stateLabel} = handleError(this.props.rawErrors);
        if (this.props.required && this.props.value === "") {
            state = "error";
            stateEmphasis = "";
            stateLabel = "Required";
        }
        if (this.props.value && this.identifyKatalInputType(this.props.schema) === NUMBER && isNaN(this.props.value)) {
            state = "error";
            stateEmphasis = "";
            stateLabel = "Not a number";
        }
        return(
            <KatInput
                tooltip-text={convertHtmlToPlainText(this.props.schema['tooltip-text'])}
                tooltip-trigger-icon="info_outline"
                tooltipPosition="right"
                disabled={this.props.disabled}
                type={TEXT}
                value={getValue(this.props.value, defaultValue)}
                onChange={(evt: any) => this.handleChange(evt, this.props.onChange, this.props.schema.default as string)}
                maxlength={getMaxLength(this.props.schema.maxLength)}
                required={this.props.required}
                state={state}
                stateEmphasis={stateEmphasis}
                stateLabel={stateLabel}
                max={this.props.schema.maximum}
                min={this.props.schema.minimum}
            />
        );
    }

    render() {
        if (this.props.label === undefined) {
            return this.input();
        } else {
            return (
                <div>
                    <KatInputGroup>
                        <KatLabel
                            className={constants.CUSTOM}
                            text={getRequiredLabel(this.props.required, this.props.label)}
                            tooltip-text={constants.ToolTip[this.props.label]}
                            tooltip-trigger-icon={constants.ToolTip['tooltip-trigger-icon']}
                            tooltipPosition={constants.ToolTip.tooltipPosition}
                        />
                        {this.input()}
                    </KatInputGroup>
                </div>
            );
        }
    }
}
export default InputWidget;
